import * as React from "react";
const SvgFiRrMeteor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meteor_svg__a)">
      <path
        fill="#062147"
        d="M9 24a8.97 8.97 0 0 1-6.364-2.632 9.01 9.01 0 0 1 0-12.728c2.256-2.26 7.18-5.532 9.914-7.282A2.242 2.242 0 0 1 16 3.24l4.86-2.9a2.02 2.02 0 0 1 2.533.283 2.034 2.034 0 0 1 .279 2.564L20.77 8a2.242 2.242 0 0 1 1.87 3.449c-1.747 2.734-5.018 7.655-7.277 9.915A8.97 8.97 0 0 1 9 24m-4.95-4.05a7.01 7.01 0 0 0 9.9 0c2.125-2.126 5.3-6.914 7.007-9.58a.23.23 0 0 0 .009-.244.23.23 0 0 0-.215-.126H19a1 1 0 0 1-.856-1.517l3.832-6.35-.028-.11-6.436 3.836A1 1 0 0 1 14 4.999V3.25a.242.242 0 0 0-.372-.206C10.962 4.749 6.172 7.928 4.05 10.05a7.01 7.01 0 0 0 0 9.9M9 19c-5.275-.138-5.273-7.863 0-8 5.275.138 5.273 7.863 0 8m0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meteor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeteor;
